/**
 * @generated SignedSource<<6cdb7e40f7f0b9c691cd747078e515d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type DeleteProjectStageInput = {
  id: string;
  moveProjectsTo?: string | null;
  allowLastWithProfile?: boolean | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type DeleteProjectStageMutation$variables = {
  input: DeleteProjectStageInput;
};
export type DeleteProjectStageMutation$data = {
  readonly deleteProjectStage: {
    readonly deletedProjectStageId: string | null;
  } | null;
};
export type DeleteProjectStageMutation = {
  variables: DeleteProjectStageMutation$variables;
  response: DeleteProjectStageMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "DeleteProjectStagePayload",
    "kind": "LinkedField",
    "name": "deleteProjectStage",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "deletedProjectStageId",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DeleteProjectStageMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DeleteProjectStageMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "46291461209552aa82c2572e3afe2359",
    "id": null,
    "metadata": {},
    "name": "DeleteProjectStageMutation",
    "operationKind": "mutation",
    "text": "mutation DeleteProjectStageMutation(\n  $input: DeleteProjectStageInput!\n) {\n  deleteProjectStage(input: $input) {\n    deletedProjectStageId\n  }\n}\n"
  }
};
})();

(node as any).hash = "27a5dfab6d6d33d4385d3c89779bc068";

export default node;
